"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Service for managing DOM assets.
 */
class AssetManager {
    /**
     * @inheritDoc
     */
    addStyle(src) {
        if (this.hasStyle(src)) {
            // In case we have a link to the same style already we will set
            // a counter to keep track how many times we needed it, so when
            // removing only when the counter gets to 0 we remove the element.
            const styleInDom = document.head.querySelector(`[href="${src}"]`);
            const counter = Number.parseInt(styleInDom.getAttribute("data-usage-count"), 10) || 0;
            styleInDom.setAttribute("data-usage-count", String(counter + 1));
            return;
        }
        const style = document.createElement("link");
        style.href = src;
        style.rel = "stylesheet";
        return new Promise((resolve, reject) => {
            document.head.appendChild(style);
            style.onload = () => resolve();
            style.onerror = () => reject(`Failed loading css: ${src}`);
        });
    }
    /**
     * @inheritDoc
     */
    removeStyle(src) {
        if (!this.hasStyle(src)) {
            return;
        }
        const style = document.head.querySelector(`[href="${src}"]`);
        const counter = Number.parseInt(style.getAttribute("data-usage-count"), 10) || 0;
        if (counter === 0) {
            document.head.removeChild(style);
        }
        else {
            style.setAttribute("data-usage-count", String(counter - 1));
        }
    }
    /**
     * @inheritDoc
     */
    hasStyle(src) {
        return !!document.head.querySelector(`[href="${src}"]`);
    }
    /**
     * @inheritDoc
     */
    loadScript(script, async = false, defer = false) {
        if (this.isScriptLoaded(script)) {
            // In case we have a link to the same script already we will set
            // a counter to keep track how many times we needed it, so when
            // removing only when the counter gets to 0 we remove the element.
            const scriptInDom = document.head.querySelector(`script[src="${script}"]`);
            const counter = Number.parseInt(scriptInDom.getAttribute("data-usage-count"), 10) || 0;
            scriptInDom.setAttribute("data-usage-count", String(counter + 1));
            return Promise.resolve();
        }
        const scriptTag = document.createElement("script");
        scriptTag.src = script;
        if (async) {
            scriptTag.setAttribute("async", "");
        }
        if (defer) {
            scriptTag.setAttribute("defer", "");
        }
        return new Promise((resolve, reject) => {
            document.head.appendChild(scriptTag);
            scriptTag.onload = () => resolve();
            scriptTag.onerror = () => reject(`Failed loading script: ${script}`);
        });
    }
    /**
     * @inheritDoc
     */
    isScriptLoaded(script) {
        return !!document.head.querySelector(`script[src="${script}"]`);
    }
    /**
     * @inheritDoc
     */
    removeScript(src) {
        if (!this.isScriptLoaded(src)) {
            return;
        }
        const script = document.head.querySelector(`script[src="${src}"]`);
        const counter = Number.parseInt(script.getAttribute("data-usage-count"), 10) || 0;
        if (counter === 0) {
            document.head.removeChild(script);
        }
        else {
            script.setAttribute("data-usage-count", String(counter - 1));
        }
    }
}
exports.default = AssetManager;
